export const APP_DEFAULT_DEEPLINK = 'https://insig.ht/app';

/**
 * Branch app download link used when a Branch link could not be generated.
 * The query string is the deep link plus any extra (utm) parameters.
 */
export const getFallbackDownloadLink = ({
  deepLink,
  ...utmParams
}: { deepLink: string } & Record<string, string>) => {
  const searchParams = new URLSearchParams({
    $deeplink_v2: deepLink,
    $deeplink: deepLink,
    ...utmParams
  });

  return `https://insig.ht/appDownload?${searchParams.toString()}`;
};

export const getSingleTrackDeepLink = (id: string) => {
  return `insight://libraries/${id}`;
};

export const getPremiumAudioTrackDeepLink = (id: string) => {
  return `insight://libraries/${id}?is_premium=true`;
};

export const getCourseDeepLink = (id: string) => {
  return `insight://courses/${id}`;
};

export const getPlaylistDeepLink = (id: string, ownerId?: string) => {
  return `insight://playlists/${id}${ownerId ? `?owner=${ownerId}` : ''}`;
};

export const getPublisherDeepLink = (id: string) => {
  return `insight://publishers/teacher/${id}`;
};

export const getGroupDeepLink = (groupId: string) => {
  return `insight://groups-v2/${groupId}`;
};

export const getChallengeDeepLink = (challengeId: string) => {
  return `insight://groups-v2/${challengeId}?is_challenge=true`;
};

export const getRetreatDeepLink = (shopProductId: string) => {
  return `insight://retreats/${shopProductId}`;
};

export interface WorkshopWebAndDeepLinkProps {
  ownerId: string;
  shopProductId: string;
  userName: string;
}

export const getWorkshopWebAndDeeplink = ({
  ownerId,
  shopProductId,
  userName
}: WorkshopWebAndDeepLinkProps) => {
  return {
    webLink: `/${userName}/workshops/${shopProductId}`,
    deepLink: `insight://shop-products/${shopProductId}?publisher_id=${ownerId}`
  };
};

export const getCoursesDeepLink = () => {
  return 'insight://discovercourses/explore';
};

export const getWalmartDeepLink = () => {
  return 'insight://walmart';
};

export const getTopicDeepLink = (topicId: string) => {
  return `insight://discoverlibraries/topics/${topicId}`;
};
